import React from 'react';
import '../styles/Hero.css';

const Hero: React.FC = () => {
  return (
    <section className="hero">
      <div className="hero-overlay"></div>
      <div className="animated-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>
      <div className="hero-content">
        <h1>Welcome to Keirin</h1>
        <p>Keirin Software Technologies stands as a global force in Software Development, IT Services, IT Skills Training, and IT Staffing. We empower organizations with intelligent, future-ready solutions built on innovation, precision, and unwavering reliability.</p>
        <a href="#services" className="cta-button">
          <span>Explore Our Services</span>
          <span className="button-arrow">→</span>
        </a>
      </div>
    </section>
  );
};

export default Hero;
